import { useMemo } from 'react';
import { useLocalStorage } from 'usehooks-ts';

const xorKey = 'uJ6v9K2sQ4F8rT1xVb3Zq7wYp0sHnL4mC5dE1fG2hI=';

function xorBase64Encode(text: string, key = xorKey): string {
  let out = '';
  for (let i = 0; i < text.length; i++) {
    out += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return btoa(out);
}

function xorBase64Decode(encoded: string, key = xorKey): string {
  const decoded = atob(encoded);
  let out = '';
  for (let i = 0; i < decoded.length; i++) {
    out += String.fromCharCode(decoded.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return out;
}

export function useLastUsedEmail() {
  const [stored, setStored] = useLocalStorage<string | null>('last-used-sso-email', null);

  const setEmail = (email: string) => {
    const encoded = xorBase64Encode(email, xorKey);
    setStored(encoded);
  };

  const clearEmail = () => setStored(null);

  const email = useMemo(() => (stored ? xorBase64Decode(stored, xorKey) : null), [stored]);

  return [email, setEmail, clearEmail] as const;
}
